import { useReducer } from 'react';
import {
  Content,
  Title,
  InputFormTable
} from 'components';
import { Select, Input, Button } from 'antd';
import { TagApi } from 'api';
import { styles } from '../styles'
import { useQueryClient } from '@tanstack/react-query';
import MessageAlert from 'utils';

const TagRegisterContent = ({ tagList }) => {
  const queryClient = useQueryClient();
  const [state, dispatch] = useReducer(
    (state, action) => {
      switch (action.type) {
        case 'CHANGE_TAG_NAME':
          return {
            ...state,
            tag_name: action.value
          };
        case 'CHANGE_IS_SHOW':
          return {
            ...state,
            is_show: action.value
          }
        case 'CLEAR':
          return {
            tag_id: null,
            tag_name: '',
            is_show: 'Y'
          }
        case 'INITIALIZE':
          return {
            ...action.value
          }
        default:
          throw new Error(`${action.type}을 찾을 수 없습니다.`);
      }
    },
    { tag_id: null, tag_name: '', is_show: 'Y' }
  );

  const handleSave = async () => {
    if (!state.tag_name) {
      MessageAlert.warning('태그 명을 입력해야 합니다.');
      return;
    }

    if (Array.isArray(tagList)) {
      const isAlreadyTagName = tagList.some((tag) => tag.tag_name === state.tag_name);
  
      if (state.tag_id === null && isAlreadyTagName) {
        MessageAlert.warning('이미 등록된 태그입니다.');
        return;
      }
    }

    const api = state.tag_id === null ? TagApi.createTag : TagApi.updateTag;
    const response = await api({ ...state });

    if (response.status === 200) {
      const message = state.tag_id === null ? '태그를 등록하였습니다.' : '태그를 수정하였습니다.';
      MessageAlert.success(message);
      
      setTimeout(() => {
        queryClient.resetQueries({ queryKey: ['tag'] }); 
        dispatch({ type: 'CLEAR' });
      }, 100)
    } else {
      MessageAlert.error('태그 등록을 실패하였습니다.');
    }
  }

  return (
    <Content
      maxWidth={'100%'}
      padding={20}
      borderRadius={4}
      style={{ marginBottom: 40 }}
    >
      <Title style={{ ...styles.subTitle }}>태그 생성</Title>
      <InputFormTable 
        form={[
          {
            label: '태그 명',
            required: true,
            form: [
              {
                input: (
                  <Input 
                    size="large" 
                    placeholder="태그 입력" 
                    value={state.tag_name} 
                    onChange={(e) => dispatch({ type: 'CHANGE_TAG_NAME', value: e.target.value })}  
                  />
                ),
                count: true,
                maxLength: 10,
              },
            ],
          },
          {
            label: '노출 여부',
            required: true,
            form: [
              {
                input: (
                  <Select
                    size="large"
                    value={state.is_show}
                    options={[
                      { label: '노출', value: 'Y' },
                      { label: '노출안함', value: 'N' },
                    ]}
                    placeholder="노출여부를 선택하세요."
                    onChange={(value) => {
                      dispatch({ type: 'CHANGE_IS_SHOW', value: value })
                    }} 
                  />
                ),
              },
            ],
          },
        ]} 
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: 20,
        }}
      >
        <Button
          size="large"
          type="primary"
          style={{ background: 'var(--primary-color)' }}
          onClick={handleSave}
        >
          태그 생성
        </Button>
      </div>
    </Content>
  )
}

export default TagRegisterContent;